import cn from 'bem-cn';
import { Skeleton, Stack } from '../../UI';

import './PromptInfoHeader.scss';
import { ScreenSize, useGetScreenSize } from '../../../hooks';

const b = cn('prompt-info-header');

export const PromptInfoHeaderSkeleton = () => {
    const screenSize = useGetScreenSize();
    const isMobile = screenSize === ScreenSize.Mobile;

    return (
        <Stack className={b()}>
            <Stack alignItems="center">
                <Skeleton variant="circular" width={80} height={80} />
            </Stack>
            <Stack spacing={8}>
                <Stack direction="row" justifyContent="center" className={b('categories')}>
                    <Skeleton variant="rounded" width={100} height={28} style={{ borderRadius: 100 }} />
                    <Skeleton variant="rounded" width={60} height={28} style={{ borderRadius: 100 }} />
                </Stack>
                <Stack spacing={4} alignItems="center">
                    <Skeleton width="80%" height={isMobile ? 28 : 36} />
                    <Skeleton width="60%" height={isMobile ? 28 : 36} />
                </Stack>
                <Stack spacing={4} alignItems="center">
                    <Skeleton width="90%" />
                    <Skeleton width="85%" />
                    <Skeleton width="70%" />
                    <Skeleton width="65%" />
                </Stack>
            </Stack>
        </Stack>
    );
};
